@if(labelName) {
	<label [ngClass]="[styles.tglBtnLabel, disabled ? styles.tglDisabled : '']">
		<ng-container *ngTemplateOutlet="template"></ng-container>
		<span [ngClass]="labelCssClass">{{ labelName }}</span>
	</label>
} @else {
	<div (click)="toggle()" [ngClass]="[styles.tglBtnLabel, disabled ? styles.tglDisabled : '']">
		 <ng-container *ngTemplateOutlet="template"></ng-container>
	</div>
}

<ng-template #template>
	<input type="checkbox" [ngClass]="[styles.tglInput, styles.visuallyHidden]" [id]="toggleId" [(ngModel)]="value" [disabled]="disabled" [attr.aria-label]="ariaLabel" (ngModelChange)="onChange()">
	<div [ngClass]="styles.tglBtn">
		<div [ngClass]="styles.tglBtnTrack">
			<div [ngClass]="styles.check" class="vb-icon vb-icon-round-check"></div>
		</div>
	</div>
</ng-template>
